export type HairLength = "short" | "long";

export type Model = {
  id: string;
  skin: string;
  hair: string;
  hairLength: HairLength;
  tone: string;
};

export const MODELS: Model[] = [
  { id: "m1", skin: "#f3d4b4", hair: "#2a1a10", hairLength: "short", tone: "Warm beige skin · black hair" },
  { id: "m2", skin: "#e8b896", hair: "#6b3a1d", hairLength: "short", tone: "Light brown skin · brown hair" },
  { id: "m3", skin: "#c98c61", hair: "#1a0f0a", hairLength: "short", tone: "Medium brown skin · black hair" },
  { id: "m4", skin: "#9a6037", hair: "#3a2010", hairLength: "short", tone: "Deep brown skin · dark brown hair" },
  { id: "m5", skin: "#f7dfc4", hair: "#c97a3a", hairLength: "short", tone: "Fair skin · auburn hair" },
  { id: "m6", skin: "#6f4a2d", hair: "#15090a", hairLength: "short", tone: "Rich brown skin · black hair" },
  { id: "m7", skin: "#f3d4b4", hair: "#2a1a10", hairLength: "long", tone: "Warm beige skin · long black hair" },
  { id: "m8", skin: "#e8b896", hair: "#6b3a1d", hairLength: "long", tone: "Light brown skin · long brown hair" },
  { id: "m9", skin: "#c98c61", hair: "#1a0f0a", hairLength: "long", tone: "Medium brown skin · long black hair" },
  { id: "m10", skin: "#9a6037", hair: "#3a2010", hairLength: "long", tone: "Deep brown skin · long dark hair" },
  { id: "m11", skin: "#f7dfc4", hair: "#c97a3a", hairLength: "long", tone: "Fair skin · long auburn hair" },
  { id: "m12", skin: "#6f4a2d", hair: "#15090a", hairLength: "long", tone: "Rich brown skin · long black hair" },
];

export const getModel = (id: string | null | undefined): Model | undefined =>
  id ? MODELS.find((m) => m.id === id) : undefined;
